import { RateSummary } from 'interfaces/RateDetails';

export const getRateTypeDetails = (detailSummary: RateSummary, unit?: string) => {
  const entries = Object.entries(detailSummary || {});
  const rateDetails = entries
    .map(entry => ({
      rate: Number.parseInt(entry[0]) / 100,
      count: entry[1],
      unit: unit,
    }))
    .map(item => ({ ...item, subtotal: item.rate * item.count }));
  return rateDetails;
}
